import React from "react"
import IPhone from "./iphone.svg"
import styles from "./index.module.scss"
import AndroidIcon from "./Android.svg"
import IOSIcon from "./iOS.svg"
import autocompleteData from "../../config/autocomplete"

const PhonePreview = ({ html, keyboard, autocomplete, android, setAndroid }) => {
  const [showModal, setShowModal] = React.useState(true)
  return (
    <div className={styles.container}>
      <IPhone className={styles.skeleton} />
      <div className={styles.screen}>
        <div className={styles.autocompleteContainer}>
          <label>
            <div className={styles.live}>
              <div>
                <b>Input:</b>{" "}
                <small>(as it renders on your current device)</small>
              </div>
              <div
                dangerouslySetInnerHTML={{
                  __html: html,
                }}
              />
            </div>
          </label>

          <div
            className={`${styles.autocompleteCard} ${
              autocomplete ? styles.hasAutocomplete : ""
            }`}
          >
            {autocomplete ? (
              <div>
                This input will autocomplete with the value:
                <code className={styles.autocompleteCode}> {autocomplete}</code>
                {autocompleteData[autocomplete] && (
                  <p>
                    <em>{autocompleteData[autocomplete].description}</em>
                    <div>
                      <a
                        className={styles.source}
                        href="https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete"
                      >
                        source
                      </a>
                    </div>
                  </p>
                )}
              </div>
            ) : (
              <div>
                This input has no explicit autocomplete prop. Add one by using
                the panel to the left.
              </div>
            )}
          </div>
        </div>
      </div>

      {keyboard && (!(android && keyboard.isModal) || showModal) && (
        <div
          className={`${styles.keyboard} ${
            keyboard.isModal && android ? styles.isModal : ""
          }`}
        >
          <img
            src={keyboard[android ? "android" : "ios"]}
            alt={keyboard.alt}
            title={`${android ? "android" : "ios"} keyboard screenshot`}
          />
        </div>
      )}

      {keyboard && android && keyboard.isModal && (
        <fieldset className={styles.modalFieldset}>
          <div>
            <div>
              <input
                type="checkbox"
                name="show-modal"
                id="showModal"
                checked={showModal}
                onClick={e => {
                  if (e.target.checked) setShowModal(true)
                  else setShowModal(false)
                }}
              />
              <label htmlFor="showModal">show overlay</label>&nbsp;
            </div>
          </div>
        </fieldset>
      )}
      <fieldset className={styles.platformFieldset}>
        <div className={styles.platformChooser}>
          <input
            id="android-platform"
            type="radio"
            name="platform"
            checked={!android}
            onChange={e => {
              if (e.target.checked) setAndroid(false)
            }}
          />
          <label htmlFor="android-platform">
            <IOSIcon />
            &nbsp;
            <div>ios</div>
          </label>
          <input
            id="ios-platform"
            type="radio"
            name="platform"
            checked={android}
            onChange={e => {
              if (e.target.checked) setAndroid(true)
            }}
          />
          <label htmlFor="ios-platform">
            <AndroidIcon className={styles.androidIcon} />
            &nbsp;
            <div>android</div>
          </label>
        </div>
      </fieldset>
    </div>
  )
}

export default PhonePreview
